import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const SizeChart = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const sizes = ["XS", "S", "M", "L", "XL", "XXL"];
  const hoodieMeasurements = [
    { name: "A - Chest Width", values: [49, 51.5, 54, 56.5, 59, 61.5] },
    { name: "B - Length", values: [63, 64.5, 66, 68.5, 70.5, 72.5] },
    { name: "C - Cuff Width", values: [49, 51.5, 54, 56.5, 59, 61.5] },
  ];

  // Styled components
  const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      height: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.grey[400],
      borderRadius: "3px",
    },
  }));

  const HeaderTableCell = styled(TableCell)(({ theme }) => ({
    backgroundColor: theme.palette.grey[100],
    fontWeight: 600,
    textAlign: "center",
    border: `1px solid ${theme.palette.divider}`,
    padding: isSmallScreen ? "8px 4px" : "12px 8px",
    fontSize: isSmallScreen ? "0.75rem" : "0.875rem",
  }));

  const BodyTableCell = styled(TableCell)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    padding: isSmallScreen ? "8px 4px" : "12px 8px",
    fontSize: isSmallScreen ? "0.75rem" : "0.875rem",
  }));

  const MeasurementNameCell = styled(BodyTableCell)(({ theme }) => ({
    fontWeight: 500,
    backgroundColor: theme.palette.grey[50],
  }));

  return (
    <Box
      sx={{
        width: "100%",
        px: isSmallScreen ? 1 : 2,
        py: 1,
        pl: isSmallScreen ? -5 : 0,
      }}
    >
      {/* Table */}
      <StyledTableContainer component={Paper} sx={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 500 }} aria-label="size chart">
          <TableHead>
            <TableRow>
              <HeaderTableCell
                sx={{ minWidth: isSmallScreen ? 100 : 150 }}
              ></HeaderTableCell>
              {sizes.map((size) => (
                <HeaderTableCell
                  key={size}
                  align="center"
                  sx={{ minWidth: 60 }}
                >
                  {size}
                </HeaderTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {hoodieMeasurements.map((row) => (
              <TableRow key={row.name}>
                <MeasurementNameCell component="th" scope="row" sx={{ pl: 2 }}>
                  {row.name}
                </MeasurementNameCell>
                {row.values.map((value, index) => (
                  <BodyTableCell key={index} align="center">
                    {value}
                  </BodyTableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>

      {/* Notes */}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontSize: isSmallScreen ? "0.7rem" : "0.75rem",
            display: "block",
            textAlign: "left",
            lineHeight: 1.4,
          }}
        >
          Please note: All measurements are in cm.
        </Typography>
      </Box>
    </Box>
  );
};

export default SizeChart;
